// 数美防刷
import events from '../../base/events';
import Cache from 'c-cache';

let cache = new Cache({
    prefix: 'ug'
});

let SM = Object.assign({
    init() {
        const hostname = location.hostname;
        let apiHost = 'fp.fengkongcloud.com';
        if (hostname == 'm.upliveapps.com') {
            apiHost = 'fp-xjp.fengkongcloud.com';
        }
        (
            function() { 
                window._smConf = {
                    organization: '3kHDvmQMHMyhMkWHki4D', //需要修改为业务 organization
                    staticHost: 'static.fengkongcloud.com',
                    apiHost 
                };
                var sm = document.createElement("script");
                sm.src = ('https:' === document.location.protocol ? 'https:' : 'http:') + '//' + _smConf.staticHost + '/fpv2.js';
                var s = document.getElementsByTagName("script")[0];
                sm.onload = ()=>{
                    $.channel.emit('smsdkLoaded');
                };
                sm.onerror = ()=>{
                    $.channel.emit('smsdkLoadedError');
                };
                s.parentNode.insertBefore(sm, s); 
            }
        )();


    },

    getSMDeviceId() {

        let defer = $.Deferred();
        // 无论是否使用游客，都产生一个smd（数美的deviceId）
        // 并且存储到本地
        let cacheDeviceId = cache.getCache('smDeviceId');

        if (!cacheDeviceId) {

            // 数美JS已经加载完成
            if (typeof SMSdk !== 'undefined') {
                window.smDeviceId = SMSdk.getDeviceId();
                cache.setCache('smDeviceId', window.smDeviceId);
                defer.resolve();
            } else {

                // 否则监听事件，等待sdk加载完成
                $.channel.on('smsdkLoaded', () => {
                    window.smDeviceId = SMSdk.getDeviceId();
                    cache.setCache('smDeviceId', smDeviceId);
                    defer.resolve();
                });

                $.channel.on('smsdkLoadedError', () => {
                    defer.resolve();
                })
            }
        } else {
            window.smDeviceId = cacheDeviceId;
            defer.resolve();
        }

        return defer;
    }

}, events);

export default SM;


// WEBPACK FOOTER //
// ./js/component/sm/index.js